import React from 'react';
import { Phone, Mail, Heart } from 'lucide-react';
import { SITE_CONFIG } from '@/lib/storage';

export const TopContactStrip: React.FC = () => {
  return (
    <div className="bg-dark-bg/95 backdrop-blur-sm border-b border-dark-border z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex flex-col items-center gap-3 text-sm">
          {/* Brand - centered at top, 20% larger */}
          <div className="flex items-center gap-2 w-full justify-center">
            <div className="w-8 h-8 rounded-xl bg-gold/10 flex items-center justify-center">
              <Heart className="h-5 w-5 text-gold" />
            </div>
            <span className="font-black text-2xl tracking-tight text-white">JB Motorcycles</span>
          </div>

          {/* Phone & Email & Facebook */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href={`tel:${SITE_CONFIG.phone.mobile.replace(/\s/g, '')}`}
              className="flex items-center gap-2 text-neutral-400 hover:text-gold transition-colors whitespace-nowrap"
            >
              <Phone className="h-4 w-4 text-gold" />
              <span>{SITE_CONFIG.phone.mobile}</span>
            </a>
            <a
              href={`mailto:${SITE_CONFIG.email.sales}`}
              className="flex items-center gap-2 text-neutral-400 hover:text-gold transition-colors whitespace-nowrap"
            >
              <Mail className="h-4 w-4 text-gold" />
              <span>{SITE_CONFIG.email.sales}</span>
            </a>
            <a
              href="https://www.facebook.com/jbmotorcycle/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-neutral-400 hover:text-gold transition-colors whitespace-nowrap"
            >
              <svg className="h-4 w-4 text-gold" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
              <span className="hidden sm:inline">Facebook</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};